// src/socket.js
import { io } from 'socket.io-client';

let socket = null;

export const connectSocket = () => {
  if (!socket) {
    //const url='http://localhost:3000';
    const url='https://vps-test.multipemain.com:3000';
    socket = io(url, {
      transports: ['websocket'],
    });
    console.log('Socket connected');
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log('Socket disconnected');
  }
};

export const getSocket = () => socket;
